// src/hooks/useBreakpoint.ts
import {useState, useEffect} from "react"
import {BreakpointOverrides, useTheme} from "@mui/joy";
import {Breakpoint} from "@mui/system/createTheme/createBreakpoints"


export function useBreakpoint() {
    const theme = useTheme()
    const breakpoints = theme.breakpoints.values
    const [width, setWidth] = useState(window.innerWidth)

    function getActiveBreakpoint(width: number): BreakpointOverrides {
        if (width >= breakpoints.xl) return "xl"
        if (width >= breakpoints.lg) return "lg"
        if (width >= breakpoints.md) return "md"
        if (width >= breakpoints.sm) return "md"
        return "xs"
    }

    useEffect(() => {
        const handler = () => setWidth(window.innerWidth)
        const observer = new ResizeObserver(handler)
        observer.observe(document.documentElement)
        return () => observer.disconnect()
    }, [])

    const active = getActiveBreakpoint(width)

    return {
        width,
        active,
        isXs: width >= breakpoints.xs && width < breakpoints.sm,
        isSm: width >= breakpoints.md && width < breakpoints.md,
        isMd: width >= breakpoints.md && width < breakpoints.lg,
        isLg: width >= breakpoints.lg && width < breakpoints.xl,
        isXl: width >= breakpoints.xl && width,
        isAtLeast: (bp: Breakpoint) => width >= breakpoints[bp],  // isAtLeast("md")
        isBelow: (bp: Breakpoint) => width < breakpoints[bp],     // isBelow("lg")
    }
}